import { User } from '../user';
import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class UpdateSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 200;
    let parsedUser = null;
    if (success)
      parsedUser = {
        id: raw?.data?.id,
        email: raw?.data?.email,
        firstName: raw?.data?.firstName,
        lastName: raw?.data?.lastName,
        phoneNumber: raw?.data?.phoneNumber,
        countryCode: raw?.data?.countryCode,
        createdAt: raw?.data?.createdAt,
        updatedAt: raw?.data?.updatedAt,
        metadata: raw?.data?.metadata || {}
      };

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;
    return {
      success,
      statusCode: raw?.statusCode || 500,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title,
      user: success ? new User(parsedUser) : null
    };
  }

  serialize(data) {
    if (!data) return null;

    const serialized = {
      email: data.email
    };

    if (data.firstName) serialized.firstName = data.firstName;
    if (data.lastName) serialized.lastName = data.lastName;
    if (data.password) serialized.password = data.password;
    if (data.metadata) serialized.metadata = data.metadata;

    return serialized;
  }
}

const errorMessages = {
  401: {
    title: 'Non autorisé',
    message: "Vous n'êtes pas autorisé à effectuer cette modification."
  },
  404: {
    title: 'Utilisateur introuvable',
    message: 'Aucun utilisateur ne correspond à cet email.'
  },
  400: {
    title: 'Erreur dans les données',
    message:
      'Les informations soumises sont invalides. Veuillez vérifier et réessayer.'
  },
  other: {
    title: "Échec de la mise à jour",
    message: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
  }
};

export const updateSerializer = new UpdateSerializer();
